<template>
  <main></main>
</template>

<script>
//import store from '../../store';

export default {
    name: 'Congrats',
    mounted() {
      //var self = this;
    },
    methods: {
        start() {
            this.$confetti.start({
                defaultSize: 6,
                particlesPerFrame: 1
            });
        },
        stop() {
            this.$confetti.stop();
        },
        love() {
            this.$confetti.update({
                particles: [
                    {
                    type: 'heart',
                    },
                    {
                    type: 'circle',
                    },
                ],
                defaultColors: [
                    'red',
                    'pink',
                    '#ba0000'
                ],
            });
        }
    }
}
</script>

<style scoped lang="scss">
main {
    z-index: -1;
}
</style>